import React, { useState } from 'react';

import './_YatButton.scss';

type Props = {
    children?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    size: string;
    variant?: string;
    uppercase?: boolean;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset' | undefined;
    classes?: string;
    icon?: React.ReactElement;
    hoverIcon?: React.ReactElement;
    thickerBorder?: boolean;
};

export const YatButton = ({
    children,
    onClick,
    size,
    variant = 'primary',
    uppercase,
    type,
    disabled,
    thickerBorder,
    classes,
    icon,
    hoverIcon,
}: Props) => {
    const [isHover, setIsHover] = useState<boolean>(false);

    // If hovering, show the specified hoverIcon.
    // If there is no hover icon, default to normal icon.
    const iconComponent = isHover ? (hoverIcon ? hoverIcon : icon) : icon;

    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            type={type && type}
            disabled={disabled && disabled}
            className={`YatButton ${variant} ${size} ${thickerBorder ? 'border-thick' : ''} ${
                uppercase ? 'uppercase' : ''
            } ${disabled ? 'disabled' : ''} ${classes && classes}`}
        >
            <span className="button-child">
                {iconComponent ? iconComponent : null}
                {children && children}
            </span>
        </button>
    );
};
